module.exports = __webpack_public_path__ + "static/media/typewriter.810532f4.jpeg";